<template>
    <div class="chart-wrapper">
        <!-- Bar Chart -->
        <div class="bar-container" :style="{ width: barWidth + 'px', height: barHeight + 'px' }">
            <div
                class="bar-section inoperable-section"
                :style="{
                    '--bar-height': inoperablePercentage + '%',
                    '--bar-color': inoperableColor,
                }"
            ></div>

            <div
                class="bar-section"
                :style="{
                    '--bar-height': operablePercentage + '%',
                    '--bar-color': operableColor,
                }"
            ></div>
        </div>

        <!-- Legend -->
        <div class="legend ml-4 flex flex-col space-y-4">
            <div class="legend-item">
                <span class="legend-color" :style="{ backgroundColor: inoperableColor }"></span>
                <span class="legend-item-title">{{ trans('dashboard.v2.critical_locations.bar_chart.inoperable') }}</span>
                <span class="legend-item-data"> {{ inoperable }} ({{ inoperablePercentage }}%) </span>
            </div>

            <div class="legend-item">
                <span class="legend-color" :style="{ backgroundColor: operableColor }"></span>
                <span class="legend-item-title">{{ trans('dashboard.v2.critical_locations.bar_chart.operable') }}</span>
                <span class="legend-item-data"> {{ operable }} ({{ operablePercentage }}%) </span>
            </div>
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue';
import { trans } from '@/mixins/i18n';
const props = defineProps({
    operable: { type: Number, required: true },
    inoperable: { type: Number, required: true },
    barWidth: { type: [Number, String], default: 26 },
    barHeight: { type: [Number, String], default: 121 },
    operableColor: { type: String, default: '#4F6BF6' },
    inoperableColor: { type: String, default: '#F6A5B3' },
});

const total = computed(() => props.operable + props.inoperable);

const operablePercentage = computed(() => (total.value ? Math.round((props.operable / total.value) * 100) : 0));

const inoperablePercentage = computed(() => (total.value ? 100 - operablePercentage.value : 0));
</script>

<style scoped>
.chart-wrapper {
    display: inline-flex;
    flex-direction: row;
    align-items: center; /* vertically center legend relative to bar */
    gap: 1rem; /* space between bar and legend */
}
.bar-container {
    position: relative;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.bar-section {
    height: var(--bar-height);
    background-color: var(--bar-color);
    border-radius: 2px;
    transition:
        height 0.3s ease-in-out,
        background-color 0.3s ease-in-out;
}

.inoperable-section {
    margin-bottom: 2px;
}

.legend-color {
    display: inline-block;
    width: 10px;
    height: 10px;
    border-radius: 3px;
    grid-row: 1 / span 2;
}

.legend {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
}

.legend-item {
    display: grid;
    grid-template-columns: 0.75rem auto; /* color box + text */
    grid-template-rows: auto auto;
    gap: 6px;
}

.legend-item-title {
    color: var(--Warm-Grey, #525252);
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 12px;
}

.legend-item-data {
    color: var(--Horizon-Haze, #8490a1);
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 12px; /* 100% */
}
</style>
